<template>
  <div data-app>
    <iq-card>
      <template v-if="header" v-slot:headerTitle>
        <slot name="headerTitle">
          <h4 class="card-title title-typography-color">
            <i class="far fa-calendar-alt"></i>
            <span v-if="professionalsSchedule && professionalsSchedule.length !== 0">
              <span v-for="(item, index) in professionalsSchedule" :key="index">
                <span v-if="item.titleProfessional && index === 0">
                  {{ $t("public.components.schedule.Schedule.agendaOf") }}
                </span>
                <span v-if="item.titleProfessional && professionalsSchedule.lengh < 2
                  ">{{ item.titleProfessional }}</span>
                <span>
                  {{ item.titleProfessional }}
                </span>
              </span>
            </span>
            <span v-else-if="visitTypeSchedule && visitTypeSchedule.length !== 0">
              <span v-for="(item, index) in visitTypeSchedule" :key="index">
                <span v-if="item.name && index === 0">
                  {{
                    $t("public.components.schedule.Schedule.agendaByTypeVisit")
                  }}
                </span>
              </span>
            </span>
            <span v-else>
              {{ $t("public.components.schedule.Schedule.title") }}</span>
          </h4>
        </slot>
      </template>

      <template v-if="header" v-slot:headerAction>
        <slot name="headerAction">
          <b-button v-if="settingsPatient.createCita || 'PROFESSIONAL' === typeSchedule" ref="btnShowCitaCrear" right
            variant="success" @click="openModal(null)">{{ $t("public.components.schedule.Schedule.btnCreate") }}
          </b-button>
        </slot>
      </template>
      <template v-slot:body>
        <v-row id="inspire" class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar color="white" flat>
                <v-btn class="mr-4" color="grey darken-2" outlined @click="setToday">{{
                  $t("public.components.schedule.Schedule.today")
                }}
                </v-btn>
                <v-btn color="grey darken-2" fab small text @click="prev">
                  <i class="fas fa-chevron-left"></i>
                </v-btn>
                <v-btn color="grey darken-2" fab small text @click="next">
                  <i class="fas fa-chevron-right"></i>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="grey darken-2" outlined v-bind="attrs" v-on="on">
                      <span>{{ typeToLabel[type] }}</span>
                      <i class="fas fa-chevron-down"></i>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>{{
                        $t("public.components.schedule.Schedule.day")
                      }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>{{
                        $t("public.components.schedule.Schedule.week")
                      }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>{{
                        $t("public.components.schedule.Schedule.month")
                      }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4
                        {{
                          $t("public.components.schedule.Schedule.days")
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="800">
              <v-calendar v-if="loadCalendar" ref="calendar" v-model="focus" :event-color="getEventColor" :events="events"
                :start="start" :type="type" :weekday-format="myDayFormat" :weekdays="weekView" color="primary"
                @change="getEvents" @click:more="moreDay" @click:date="viewDay">
                <template v-slot:interval="{ date }">
                  <div v-if="settingsPatient.createCita ||
                    typeSchedule == 'PROFESSIONAL'
                    " class="fill-height cursor-point" @click.stop="openModal(date)"></div>
                </template>
                <template v-slot:day-label-header="{ date, day }">
                  <div v-if="settingsPatient.createCita ||
                    typeSchedule == 'PROFESSIONAL'
                    " class="fill-height cursor-point" @click.stop="openModal(date)">
                    <button :class="{
                      'btn-cita':
                        settingsPatient.createCita ||
                        typeSchedule == 'PROFESSIONAL',
                      'btn-cita-workschedule':
                        workScheduleDates.size !== 0 ||
                        (workScheduleDates.size !== 0 &&
                          workScheduleDates.has(date)),
                      'btn-now':
                        new Date(date).getDate() === new Date().getDate() &&
                        new Date(date).getMonth() === new Date().getMonth() &&
                        new Date(date).getYear() === new Date().getYear(),
                    }"
                      class="
                                                                                                                              v-btn v-btn--depressed v-btn--fab v-btn--round
                                                                                                                              theme--light
                                                                                                                              v-size--small
                                                                                                                            "
                      type="button" @click="
                        type = 'day';
                      start = date;
                      ">
                      <span class="v-btn__content">{{ day }}</span>
                    </button>
                    <div class="btn-new-cita">
                      <i v-if="settingsPatient.createCita ||
                        typeSchedule == 'PROFESSIONAL'
                        " class="fas fa-plus-square fa-xs" @click.stop="openModal(date)"></i>
                    </div>
                  </div>
                </template>
                <template v-slot:day="{ date }">
                  <v-row :id="'popover-target-' + date" v-if="settingsPatient.createCita ||
                    typeSchedule == 'PROFESSIONAL'
                    " class="fill-height cursor-point" @click.stop="openModal(date)">
                  </v-row>
                  <b-popover :target="'popover-target-' + date" triggers="hover" placement="top"
                    v-if="filterEvents(date).length !== 0">
                    <template #title><b>{{ date }}</b></template>

                    <div class="user-details-block">
                      <div v-if="event"
                        :style="'background-color: ' + event.color + '; cursor: pointer; border-radius: 10px; margin-top:2px; padding:2px;'"
                        v-for="(event, index) in filterEvents(date)" :key="index"
                        @click="getEvent(event.id, event.start)">
                        <span>{{ event.startRaw | adjustToTimezone("HH:mm") }}</span>

                        <span v-if="event.paid" class="fa-stack fa-sm-custom">
                          <i class="fa fa-money-bill-wave fa-stack-1x"></i>
                        </span>
                        <span v-else class="fa-stack fa-sm-custom">
                          <i class="fa fa-money-bill-wave fa-stack-1x"></i>
                          <i class="fa fa-ban fa-stack-2x text-danger"></i>
                        </span>

                        <span v-if="event.online" class="fa-stack fa-sm-custom">
                          <i class="fas fa-video fa-stack-1x"></i>
                        </span>
                        <span v-else class="fa-stack fa-sm-custom">
                          <i class="fas fa-video fa-stack-1x"></i>
                          <i class="fa fa-ban fa-stack-2x text-danger"></i>
                        </span>

                        <span v-if="event.invoice" class="mr-2 badge badge-pill badge-success">F</span>

                        <span v-if="typeSchedule == 'PROFESSIONAL' && event.name">{{ event.name }}</span>
                        <span v-else>{{ event.professional.name }}</span>
                      </div>
                    </div>
                  </b-popover>
                </template>
                <template v-slot:event="{ event }">
                  <div @click.stop="getEvent(event.id, event.start)">
                    <EventInfo :event="event" :typeSchedule="typeSchedule"></EventInfo>
                  </div>
                </template>

                <template v-slot:day-label="{ date, day }">
                  <div v-if="settingsPatient.createCita ||
                    typeSchedule == 'PROFESSIONAL'
                    " class="fill-height cursor-point" @click.stop="openModal(date)">
                    <button :class="{
                      'btn-cita':
                        settingsPatient.createCita ||
                        typeSchedule == 'PROFESSIONAL',
                      'btn-cita-workschedule':
                        workScheduleDates.size === 0 ||
                        (workScheduleDates.size !== 0 &&
                          workScheduleDates.has(date)),
                      'btn-now':
                        new Date(date).getDate() === new Date().getDate() &&
                        new Date(date).getMonth() === new Date().getMonth() &&
                        new Date(date).getYear() === new Date().getYear(),
                    }"
                      class="
                                                                                                                              v-btn v-btn--depressed v-btn--fab v-btn--round
                                                                                                                              theme--light
                                                                                                                              v-size--small
                                                                                                                            "
                      type="button" @click="
                        type = 'day';
                      start = date;
                      ">
                      <span class="v-btn__content">{{ day }}</span>
                    </button>
                    <div class="btn-new-cita">
                      <i v-if="settingsPatient.createCita ||
                        typeSchedule == 'PROFESSIONAL'
                        " class="fas fa-plus-square fa-xs" @click.stop="openModal(date)"></i>
                    </div>
                  </div>
                </template>
              </v-calendar>
              <v-menu v-model="selectedOpen" :activator="selectedElement" :close-on-content-click="false" offset-x>
                <v-card color="grey lighten-4" flat min-width="350px">
                  <v-toolbar :color="selectedEvent.color" dark>
                    <v-btn icon>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                    <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <span v-html="selectedEvent.details"></span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="secondary" text @click="selectedOpen = false">{{
                      $t("public.components.schedule.Schedule.btnCancel")
                    }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </template>
    </iq-card>

    <b-modal id="modal-cita" centered size="xl">
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="secondary" @click="cancel()">
          {{ $t("public.components.schedule.Schedule.modalCreate.btnCancel") }}
        </b-button>
        <span v-if="!cita.finishedAt">
          <b-button v-if="!btnVideoconference" class="mr-2" size="sm" variant="primary"
            @click="videoconference(cita.paymentPlace, cita.paid)">
            {{
              $t(
                "public.components.schedule.Schedule.modalCreate.videoConference"
              )
            }}
          </b-button>
        </span>
        <b-button v-if="!btnCancel" size="sm" variant="danger" @click="deleteEvent(cita.id)">
          {{ $t("public.components.schedule.Schedule.modalCreate.cancel") }}
        </b-button>
        <b-button v-if="typeSchedule !== 'PATIENT'" size="sm" variant="warning"
          @click="openReschedule(cita.id, cita.startAt)">
          {{ $t("public.components.schedule.Schedule.modalCreate.reschedule") }}
        </b-button>
      </template>
      <template #modal-title>{{ $t("public.components.schedule.Schedule.modalRefresh.title") }}

        <span v-if="cita.eventPlace === 'ONLINE'" class="badge badge-pill badge-success ml-2 text-uppercase mr-2">{{
          $t("public.components.schedule.Schedule.modalCreate.online")
        }}</span>
        <span v-if="cita.eventPlace === 'OFFLINE'" class="badge badge-pill badge-danger ml-2 text-uppercase mr-2">{{
          $t("public.components.schedule.Schedule.modalCreate.offline")
        }}</span>
        <b-badge v-if="cita.force" class="text-uppercase mr-2" variant="danger">{{
          $t("public.components.schedule.Schedule.modalCreate.outOfDate")
        }}
        </b-badge>

        <b-badge v-if="cita.finishedAt" class="text-uppercase" variant="warning">{{
          $t("public.components.schedule.Schedule.modalCreate.finished")
        }}
        </b-badge>
      </template>

      <template #modal-ok>{{
        $t(
          "public.components.schedule.Schedule.modalRefresh.btnVideoconference"
        )
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalRefresh.btnCancel")
      }}
      </template>
      <form action="#">
        <div class="form-row">
          <div class="col-md-12 mb-12">
            <b-form-group label-for="professionalModalCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.professional"
                )
              }}:
              </template>
              <ul class="list-group">
                <li v-if="cita.professionalLead" class="list-group-item">
                  <b-avatar class="mr-2" v-bind:src="cita.professionalLead.avatarUrl
                    ? cita.professionalLead.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                    "></b-avatar>
                  {{ cita.professionalLead.name }}
                  {{ cita.professionalLead.lastname }}
                  <b-badge pill variant="primary text-uppercase">{{
                    $t(
                      "public.components.schedule.Schedule.modalRefresh.leader"
                    )
                  }}
                  </b-badge>
                </li>
              </ul>
            </b-form-group>
          </div>
          <div v-if="cita.professionals && cita.professionals.length !== 0" class="col-md-12 mb-12">
            <b-form-group label-for="professionalsCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.professionals"
                )
              }}:
              </template>
              <ul class="list-group">
                <li v-for="(item, index) in cita.professionals" :key="index" :item="item" class="list-group-item">
                  <b-avatar class="mr-2" v-bind:src="item.avatarUrl
                    ? item.avatarUrl +
                    '/' +
                    getAuthentication()
                    : ''
                    "></b-avatar>
                  {{ item.name }}
                  {{ item.lastname }}
                </li>
              </ul>
            </b-form-group>
          </div>
          <div class="col-md-12 mb-12">
            <b-form-group label-for="patientModalCita">
              <template v-if="cita.billings && cita.billings.length !== 0" slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.patients"
                )
              }}:
              </template>
              <ul class="list-group">
                <li v-for="(item, index) in cita.billings" :key="index" :item="item" class="list-group-item">
                  <div>
                    <b-row>
                      <b-col cols="10">
                        <b-avatar class="mr-2" v-bind:src="item.patient.avatarUrl
                          ? item.patient.avatarUrl +
                          '/' +
                          getAuthentication()
                          : ''
                          "></b-avatar>
                        {{ item.patient.name }} {{ item.patient.lastname }} ({{
                          item.patient.phone
                        }})

                        <span v-if="(typeSchedule === 'PATIENT' &&
                              item.patient.id == userId) ||
                            typeSchedule !== 'PATIENT'
                            ">
                          <b-badge v-if="item.payment &&
                            item.payment.paymentMode !== 'OUT_PLATAFORM' &&
                            item.payment.paymentStatus === 'SUCCESS'
                            " class="mr-2 text-uppercase" variant="success">{{
    $t(
      "public.components.schedule.Schedule.modalRefresh.paid"
    )
  }}</b-badge>
                          <b-badge v-if="item.payment &&
                              item.payment.paymentMode !== 'OUT_PLATAFORM' &&
                              item.payment.paymentStatus === 'PENDING'
                              " class="mr-2 text-uppercase" variant="warning">{{
      $t(
        "public.components.schedule.Schedule.modalRefresh.processingPayment"
      )
    }}</b-badge>
                          <b-badge v-if="item.payment &&
                              item.payment.paymentMode === 'OUT_PLATAFORM' &&
                              item.payment.paymentOutPlataform
                              " class="mr-2 text-uppercase" variant="success">{{
      $t(
        "public.components.schedule.Schedule.modalRefresh.paid"
      )
    }}
                            ({{
                              item.payment.paymentOutPlataform.name
                            }})</b-badge>
                          <b-badge v-if="!item.payment ||
                              item.payment.paymentStatus === 'CANCEL'
                              " class="mr-2 text-uppercase" variant="danger">{{
      $t(
        "public.components.schedule.Schedule.modalRefresh.unPaid"
      )
    }}</b-badge>
                        </span>
                      </b-col>
                      <b-col v-if="(typeSchedule === 'PATIENT' &&
                            item.patient.id == userId) ||
                          typeSchedule !== 'PATIENT'
                          " cols="2">
                        <div class="div-table-data-modal">
                          <button :id="'btnMore' + item.patient.id" v-b-toggle="'more-info-patient-' + item.patient.id"
                            class="item" @click="morePrevent">
                            <i class="ri-add-line icon-remix-icon-modal"></i>
                          </button>
                          <b-popover :target="'btnMore' + item.patient.id" placement="botton" triggers="hover focus">
                            <template #title>{{
                              $t(
                                "public.components.schedule.Schedule.modalRefresh.moreInfo"
                              )
                            }}
                            </template>
                          </b-popover>

                          <button v-if="(!item.payment ||
                                item.payment.paymentStatus !== 'SUCCESS') &&
                              typeSchedule === 'PATIENT'
                              " :id="'btnPaid' + item.patient.id" class="item"
                            @click="openModalPay($event, item.patient.id)">
                            <i class="ri-bank-card-line icon-remix-icon-modal"></i>
                          </button>
                          <b-popover :target="'btnPaid' + item.patient.id" placement="botton" triggers="hover focus">
                            <template #title>{{
                              $t(
                                "public.components.schedule.Schedule.modalRefresh.pay"
                              )
                            }}
                            </template>
                          </b-popover>

                          <button v-if="typeSchedule == 'PROFESSIONAL' && !item.payment
                              " :id="'btnMarkPaid' + item.patient.id" class="item" @click="
      checkPaidForProfessional(
        $event,
        cita.id,
        item.patient.id
      )
      ">
                            <i class="ri-check-line icon-remix-icon-modal"></i>
                          </button>
                          <b-popover :target="'btnMarkPaid' + item.patient.id" placement="botton" triggers="hover focus">
                            <template #title>{{
                              $t(
                                "public.components.schedule.Schedule.modalRefresh.markPaid"
                              )
                            }}
                            </template>
                          </b-popover>

                          <button v-if="item.invoices && item.invoices.length !== 0"
                            :id="'btnDownloadInvoice' + item.patient.id" class="item"
                            @click="downloadInvoice($event, item.invoices)">
                            <i
                              class="
                                                                                                                                      ri-file-download-line
                                                                                                                                      icon-remix-icon-modal
                                                                                                                                    "></i>
                          </button>
                          <b-button v-else-if="typeSchedule == 'PROFESSIONAL' &&
                            (!item.invoices || item.invoices.length === 0)
                            " :id="'btnGenerateInvoice' + item.patient.id" variant="success" @click="
    generateInvoice($event, cita.id, item.patient.id)
    ">
                            Facturar
                          </b-button>
                          <b-popover :target="'btnDownloadInvoice' + item.patient.id" placement="botton"
                            triggers="hover focus">
                            <template #title>{{
                              $t(
                                "public.components.schedule.Schedule.modalRefresh.downloadInvoice"
                              )
                            }}
                            </template>
                          </b-popover>
                        </div>
                      </b-col>
                    </b-row>
                    <b-collapse :id="'more-info-patient-' + item.patient.id">
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li v-if="item.paymentPlace === 'WALLET'">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.methodPayment"
                                )
                              }}:
                              </span>
                              {{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.wallet"
                                )
                              }}
                            </li>
                            <li v-if="item.paymentPlace === 'OUT_PLATAFORM'">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.methodPayment"
                                )
                              }}: </span>{{
  $t(
    "public.components.schedule.Schedule.modalCreate.notRequiredPay"
  )
}}
                            </li>
                            <li v-if="item.paymentPlace === 'BEFORE_EVENT_ONLINE'">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.methodPayment"
                                )
                              }}: </span>{{
  $t(
    "public.components.schedule.Schedule.modalCreate.payBefore"
  )
}}
                            </li>

                            <li v-if="item.paymentPlace === 'AFTER_EVENT_ONLINE'">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.methodPayment"
                                )
                              }}: </span>{{
  $t(
    "public.components.schedule.Schedule.modalCreate.payAfter"
  )
}}
                            </li>
                            <li v-if="item.paymentPlace &&
                                (item.paymentPlace === 'BEFORE_EVENT_ONLINE' ||
                                  item.paymentPlace === 'AFTER_EVENT_ONLINE') &&
                                item.payment &&
                                item.payment.paymentMode === 'PAYPAL' &&
                                item.payment.paypalPayment &&
                                item.payment.paymentStatus === 'SUCCESS'
                                ">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.paidPaypal"
                                )
                              }}: </span>{{ item.payment.paypalPayment }}
                            </li>
                            <li v-if="item.paymentPlace &&
                              (item.paymentPlace === 'BEFORE_EVENT_ONLINE' ||
                                item.paymentPlace === 'AFTER_EVENT_ONLINE') &&
                              item.payment &&
                              item.payment.paymentMode === 'STRIPE' &&
                              item.payment.stripeSession &&
                              item.payment.paymentStatus === 'SUCCESS'
                              ">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.paidStripe"
                                )
                              }}: </span>{{ item.payment.stripeSession }}
                            </li>
                            <li v-if="item.paymentPlace &&
                              (item.paymentPlace === 'BEFORE_EVENT_ONLINE' ||
                                item.paymentPlace === 'AFTER_EVENT_ONLINE') &&
                              item.payment &&
                              item.payment.paymentMode === 'CASH' &&
                              item.payment.paymentStatus === 'SUCCESS'
                              ">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.paidWallet"
                                )
                              }}
                              </span>
                            </li>
                            <li v-if="item.price">
                              <span class="ml-2 font-weight-bold">{{
                                $t(
                                  "public.components.schedule.Schedule.modalCreate.sessionPrice"
                                )
                              }}: </span>{{ item.price }} €
                            </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </div>
                </li>
              </ul>
            </b-form-group>
          </div>
          <div class="col-md-6 mb-2">
            <b-form-group label-for="tiempoModalCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.startAt"
                )
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">{{ cita.startAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}</li>
              </ul>
            </b-form-group>
          </div>
          <div class="col-md-6 mb-2">
            <b-form-group label-for="tiempoModalCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.duration"
                )
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">{{ cita.time }} Minutos</li>
              </ul>
            </b-form-group>
          </div>
          <div class="col-md-6 mb-2">
            <b-form-group label-for="tiempoUsoModalCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.durationUse"
                )
              }}:
              </template>
              <ul class="list-group">
                <li class="list-group-item">{{ cita.totalMinutes }} Minutos</li>
              </ul>
            </b-form-group>
          </div>

          <div v-if="typeSchedule !== 'PATIENT' && cita.comments" class="col-md-12 mb-6">
            <b-form-group label-for="referenceModalCita">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalRefresh.comments"
                )
              }}:
              </template>

              <ul class="list-group">
                <li v-if="cita.comments" class="list-group-item">
                  {{ cita.comments }}
                </li>
              </ul>
            </b-form-group>
          </div>
          <div class="col-md-12 mb-6">
            <b-form-group label-for="tipoModalCita">
              <template slot="label">{{
                $t("public.components.schedule.Schedule.modalRefresh.type")
              }}:
              </template>

              <ul class="list-group">
                <li v-if="cita.visitType" class="list-group-item">
                  <i :style="'color: ' + cita.visitType.colour" class="fas fa-circle mr-2"></i>
                  {{ cita.visitType.name }}
                </li>
              </ul>
            </b-form-group>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-cita-crear" centered size="lg" @ok="saveFormNewEvent">
      <template #modal-title><span v-if="create">
          {{ $t("public.components.schedule.Schedule.modalCreate.title") }}
        </span>
        <span v-else>
          {{
            $t("public.components.schedule.Schedule.modalCreate.titleUpdate")
          }}
        </span>
        <b-badge v-if="force" class="text-uppercase" variant="danger">{{
          $t("public.components.schedule.Schedule.modalCreate.forceOutOfDate")
        }}
        </b-badge>
      </template>
      <template #modal-ok>
        <div v-if="create">
          {{ $t("public.components.schedule.Schedule.modalCreate.btnCreate") }}
        </div>
        <div v-else>
          {{ $t("public.components.schedule.Schedule.modalCreate.btnUpdate") }}
        </div>
      </template>
      <template #modal-cancel>{{
        $t("public.auth.patient.schedule.modalCreate.btnCancel")
      }}
      </template>
      <b-form-group v-if="typeSchedule !== 'PATIENT' &&
          professionalsSchedule &&
          professionalsSchedule.length !== 0
          " label-for="professional">
        <template slot="label">{{
          $t("public.components.schedule.Schedule.modalCreate.professional")
        }}: *
        </template>
        <multiselect v-model="newEvent.professionalLeads" :options="professionalsSchedule" :preserve-search="true"
          label="titleProfessional" track-by="idProfessional" v-bind:deselectGroupLabel="$t(
            'public.components.schedule.Schedule.multiselect.professional.deselectGroupLabel'
          )
            " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.professional.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.components.schedule.Schedule.multiselect.professional.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.professional.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.components.schedule.Schedule.multiselect.professional.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.professional.selectedLabel'
  )
    ">
          <template slot="singleLabel" slot-scope="props">
            <div v-if="props.option">
              <b-avatar class="mr-3" v-bind:src="props.option.avatarUrl
                ? props.option.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <span v-if="props.option.titleProfessional" class="mr-auto">{{
                props.option.titleProfessional
              }}</span>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <b-list-group-item v-if="props.option" class="d-flex align-items-center">
              <b-avatar class="mr-3" v-bind:src="props.option.avatarUrl
                ? props.option.avatarUrl +
                '/' +
                getAuthentication()
                : ''
                "></b-avatar>
              <span v-if="props.option.titleProfessional" class="mr-auto title-typography-color">{{
                props.option.titleProfessional
              }}</span>
            </b-list-group-item>
          </template>
        </multiselect>
        <ul v-if="isFormNewEventprofessionalErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.professional'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group v-else-if="typeSchedule !== 'PATIENT' && newEvent.professionalLead">
        <template slot="label">{{
          $t("public.components.schedule.Schedule.modalCreate.professional")
        }}: *
        </template>
        <ul class="list-group">
          <li class="list-group-item">
            <b-avatar class="mr-2" v-bind:src="newEvent.professionalLead.avatarUrl
                  ? newEvent.professionalLead.avatarUrl +
                  '/' +
                  getAuthentication()
                  : ''
                "></b-avatar>
            {{ newEvent.professionalLead.name }}
            {{ newEvent.professionalLead.lastname }} ({{
              newEvent.professionalLead.phone
            }})
            <b-badge pill variant="primary">Líder</b-badge>
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="date">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.date") }}:
          *
        </template>
        <date-picker v-model="dateTmp" :disabled-date="disabledDate" :format="myFormat" :formatter="momentFormat"
          type="date" v-bind:class="{
            'text-danger': isFormNewEventDateErrors,
            'is-invalid': isFormNewEventDateErrors,
          }" @pick="calculateTimeDay"></date-picker>
        <vue-timepicker v-model="timeTmp" :hour-range="hourRange" :minute-range="minuteRange" v-bind:class="{
          'text-danger': isFormNewEventTimeErrors,
          'is-invalid': isFormNewEventTimeErrors,
        }" @change="calculateMinutesHour"></vue-timepicker>
        <ul v-if="isFormNewEventDateErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.date'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="type">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.type") }}:
          *
        </template>

        <multiselect id="type-multiselect" v-model="newEvent.type" :options="typeSelect" :preserve-search="true"
          label="text" track-by="value" v-bind:class="{
            'text-danger': isFormNewEventTypeErrors,
            'is-invalid': isFormNewEventTypeErrors,
          }" v-bind:deselectGroupLabel="$t(
  'public.components.schedule.Schedule.multiselect.visitType.deselectGroupLabel'
)
  " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.components.schedule.Schedule.multiselect.visitType.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectedLabel'
  )
    " @blur="checkNewEventType(newEvent.type)" @input="
    changeVisitType();
  getEventTotal();
  changeToInteractive();
  ">
          <template slot="singleLabel" slot-scope="{ option }">
            <i :style="'color: ' + option.colour" class="fas fa-circle mr-2"></i>
            {{ option.text }}
          </template>
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
        </multiselect>
        <ul v-if="isFormNewEventTypeErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.type'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group v-if="boxSelect && boxSelect.length !== 0" label-for="box">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.box") }}:
        </template>
        <b-form-select id="box" v-model="newEvent.box" :options="boxSelect" class="form-control"></b-form-select>
      </b-form-group>
      <b-form-group label-for="eventPlace">
        <template slot="label">{{
          $t("public.components.schedule.Schedule.modalCreate.eventPlace")
        }}: *
        </template>
        <b-form-select id="eventPlace" v-model="newEvent.eventPlace" :options="eventPlaceSelect" class="form-control"
          v-bind:class="{
            'text-danger': isFormNewEventPlaceErrors,
            'is-invalid': isFormNewEventPlaceErrors,
          }" @blur="checkNewEventPlace(newEvent.eventPlace)" @input="
  changeVisitType();
getEventTotal();
"></b-form-select>

        <ul v-if="isFormNewEventPlaceErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.eventPlace'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group v-if="typeSchedule !== 'PATIENT' &&
        newEvent &&
        newEvent.onlineType === 'MULTICONFERENCE'
        " label-for="contacts">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.contacts") }}:
          *
        </template>
        <b-container>
          <b-row v-for="(item, index) in contactsMulticonference" :key="index" :item="item"
            class="bq-warning-light border mb-2">
            <b-col cols="11">
              <b-form-group v-slot="{ ariaDescribedby }">
                <template slot="label">{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.contactType"
                  )
                }}:
                </template>
                <b-form-radio-group v-model="item.type" :aria-describedby="ariaDescribedby" :name="'radio-inline' + index"
                  :options="typeContactOptions"></b-form-radio-group>
              </b-form-group>
              <b-form-group v-if="item.type === 'PATIENT'" label-for="patient">
                <template slot="label">{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.patient"
                  )
                }}: *
                </template>
                <multiselect id="contact-multiselect" v-model="item.contact" :clear-on-select="false"
                  :close-on-select="false" :loading="isLoadingPatients" :options="patientSelect" :preselect-first="true"
                  :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="$t(
                    'public.components.schedule.Schedule.multiselect.deselectGroupLabel'
                  )
                    " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.components.schedule.Schedule.multiselect.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectedLabel'
  )
    " @search-change="getAllPatients">
                  <template slot="noResult">
                    {{ $t("generic.noResults") }}
                  </template>
                  <template slot="noOptions">
                    {{ $t("generic.min3") }}
                  </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <b-avatar class="mr-3" v-bind:src="option.avatar"></b-avatar>
                    <span class="mr-auto">{{ option.text }}</span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <b-list-group-item class="d-flex align-items-center">
                      <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                      <span class="mr-auto title-typography-color">{{
                        props.option.text
                      }}</span>
                    </b-list-group-item>
                  </template>
                </multiselect>
              </b-form-group>
              <b-form-group v-else label-for="professional">
                <template slot="label">{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.professional"
                  )
                }}: *
                </template>
                <multiselect id="contact-multiselect-1" v-model="item.contact" :options="professionalSelect"
                  :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="$t(
                    'public.components.schedule.Schedule.multiselect.deselectGroupLabel'
                  )
                    " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.components.schedule.Schedule.multiselect.placeholder2'
  )
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectedLabel'
  )
    ">
                  <template slot="singleLabel" slot-scope="{ option }">
                    <b-avatar class="mr-3" v-bind:src="option.avatar"></b-avatar>
                    <span class="mr-auto">{{ option.text }}</span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <b-list-group-item class="d-flex align-items-center">
                      <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                      <span class="mr-auto title-typography-color">{{
                        props.option.text
                      }}</span>
                    </b-list-group-item>
                  </template>
                </multiselect>
              </b-form-group>
              <ul v-if="isFormContactsErrors('CONTACT', index)">
                <li v-for="(error, index) in isValidateNewEvent.getErrors(
                  'newEvent.contacts[' + index + '].contact'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-col>
            <b-col cols="1">
              <i v-if="contactsMulticonference && contactsMulticonference.length > 2
                " class="fas fa-trash-alt text-danger cursor-point" @click="removeContact(index)"></i>
            </b-col>
            <b-col v-if="item.type === 'PATIENT'" cols="3">
              <b-form-group label-for="price">
                <template slot="label">{{
                  $t(
                    "public.components.schedule.Schedule.modalRefresh.price"
                  )
                }}: *
                </template>
                <b-form-input v-model="item.price" type="number" v-bind:class="{
                  'text-danger': isFormContactsErrors('PRICE', index),
                  'is-invalid': isFormContactsErrors('PRICE', index),
                }"></b-form-input>
              </b-form-group>
              <ul v-if="isFormContactsErrors('PRICE', index)">
                <li v-for="(error, index) in isValidateNewEvent.getErrors(
                  'newEvent.contacts[' + index + '].price'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-col>
            <b-col v-if="item.type === 'PATIENT'" cols="8">
              <b-form-group label-for="paymentPlace">
                <template slot="label">{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.methodPayment"
                  )
                }}: *
                </template>
                <b-form-select v-model="item.paymentPlace" :options="paymentPlaceContactSelect(item.contact)"
                  class="form-control" v-bind:class="{
                    'text-danger': isFormContactsErrors('PAYMENT_PLACE', index),
                    'is-invalid': isFormContactsErrors('PAYMENT_PLACE', index),
                  }" @blur="checkNewEventPaymentPlace(item.paymentPlace)"></b-form-select>
              </b-form-group>
              <ul v-if="isFormContactsErrors('PAYMENT_PLACE', index)">
                <li v-for="(error, index) in isValidateNewEvent.getErrors(
                  'newEvent.contacts[' + index + '].paymentPlace'
                )" v-bind:key="index" class="form-text text-danger">
                  &nbsp;{{ error }}
                </li>
              </ul>
            </b-col>
            <b-col>
              <b-form-group v-if="item.paymentPlace === 'WALLET'" label-for="discount">
                <b-row>
                  <b-col>
                    <b-badge class="mr-2" variant="success">{{
                      $t(
                        "public.components.schedule.Schedule.currentBalance"
                      )
                    }}: {{ item.contact.walletBalance }} €.
                    </b-badge>
                  </b-col>
                </b-row>
                <div v-if="item.contact.walletBalance <= 0">
                  <b-alert v-if="item.contact.walletBalance &&
                    newEvent.price > item.contact.walletBalance
                    " show variant="danger">{{
    $t("public.components.schedule.Schedule.unableDescount")
  }}
                  </b-alert>
                  <b-alert v-if="item.contact.walletBalance &&
                      newEvent.price <= item.contact.walletBalance
                      " show variant="warning">{{
      $t("public.components.schedule.Schedule.descount")
    }}
                  </b-alert>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button right variant="success" @click="addContact">{{
            $t("public.components.schedule.Schedule.add")
          }}
          </b-button>
        </b-container>
      </b-form-group>
      <div v-else>
        <b-form-group v-if="typeSchedule !== 'PATIENT'" label-for="contact">
          <template slot="label">{{
            $t("public.components.schedule.Schedule.modalCreate.contact")
          }}: *
          </template>
          <multiselect id="contact-multiselect-2" v-model="newEvent.contact" :clear-on-select="false"
            :close-on-select="false" :loading="isLoadingPatients" :options="patientSelect" :preselect-first="true"
            :preserve-search="true" label="text" track-by="value" v-bind:class="{
              'text-danger': isFormNewEventContactErrors,
              'is-invalid': isFormNewEventContactErrors,
            }" v-bind:deselectGroupLabel="$t(
  'public.components.schedule.Schedule.multiselect.deselectGroupLabel'
)
  " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.deselectLabel'
  )
    " v-bind:placeholder="$t('public.components.schedule.Schedule.multiselect.placeholder')
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectGroupLabel'
  )
    " v-bind:selectLabel="$t('public.components.schedule.Schedule.multiselect.selectLabel')
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.selectedLabel'
  )
    " @blur="checkNewEventType(newEvent.type)" @input="
    loadingWalletTotalPaymentPlaceSelect();
  getPatientWalletBalance(newEvent.contact);
  " @search-change="getAllPatients">
            <template slot="noResult">
              {{ $t("generic.noResults") }}
            </template>
            <template slot="noOptions">
              {{ $t("generic.min3") }}
            </template>
            <template slot="singleLabel" slot-scope="{ option }">
              <b-avatar class="mr-3" v-bind:src="option.avatar"></b-avatar>
              <span class="mr-auto">{{ option.text }}</span>
            </template>
            <template slot="option" slot-scope="props">
              <b-list-group-item class="d-flex align-items-center">
                <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                <span class="mr-auto title-typography-color">{{
                  props.option.text
                }}</span>
              </b-list-group-item>
            </template>
          </multiselect>

          <ul v-if="isFormNewEventContactErrors">
            <li v-for="(error, index) in isValidateNewEvent.getErrors(
              'newEvent.contact'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group v-else label-for="contact">
          <template slot="label">{{
            $t("public.components.schedule.Schedule.modalCreate.contact")
          }}: *
          </template>
          <b-form-input id="contact" v-model="newEvent.contactText" readonly type="text" v-bind:class="{
            'text-danger': isFormNewEventContactErrors,
            'is-invalid': isFormNewEventContactErrors,
          }" @blur="checkNewEventContact(newEvent.contact)"
            @input="loadingWalletTotalPaymentPlaceSelect()"></b-form-input>
          <ul v-if="isFormNewEventContactErrors">
            <li v-for="(error, index) in isValidateNewEvent.getErrors(
              'newEvent.contact'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="price">
          <template slot="label">{{ $t("public.components.schedule.Schedule.modalRefresh.price") }}:
            *
          </template>
          <b-form-input v-model="newEvent.price" type="number" v-bind:class="{
            'text-danger': isFormNewEventPriceErrors,
            'is-invalid': isFormNewEventPriceErrors,
          }"></b-form-input>
        </b-form-group>
        <ul v-if="isFormNewEventPriceErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.price'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>

        <b-form-group label-for="payment">
          <template slot="label">{{
            $t("public.components.schedule.Schedule.modalCreate.paymentType")
          }}: *
          </template>

          <b-form-select v-model="newEvent.paymentPlace" :options="paymentPlaceSelect" class="form-control" v-bind:class="{
            'text-danger': isFormNewEventPaymentPlaceErrors,
            'is-invalid': isFormNewEventPaymentPlaceErrors,
          }" @blur="
  checkNewEventPaymentPlace(newEvent.paymentPlace);
loadingWalletTotalPaymentPlaceSelect();
" @input="loadingWalletTotalPaymentPlaceSelect"></b-form-select>
          <ul v-if="isFormNewEventPaymentPlaceErrors">
            <li v-for="(error, index) in isValidateNewEvent.getErrors(
              'newEvent.paymentPlace'
            )" v-bind:key="index" class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </div>
      <b-form-group v-if="newEvent.paymentPlace === 'WALLET' &&
        newEvent.onlineType !== 'MULTICONFERENCE'
        " label-for="discount">
        <b-row v-if="patient && patient.walletBalance != undefined">
          <b-col>
            <b-badge class="mr-2" variant="success">{{ $t("public.components.schedule.Schedule.currentBalance") }}:
              {{ patient.walletBalance }} €.
            </b-badge>
          </b-col>
        </b-row>
        <div v-if="patient && newEvent.price != undefined && patient.walletBalance >= 0
          ">
          <b-alert v-if="newEvent.price > patient.walletBalance" show variant="danger">{{
            $t("public.components.schedule.Schedule.unableDescount")
          }}
          </b-alert>
          <b-alert v-if="newEvent.price <= patient.walletBalance" show variant="warning">{{
            $t("public.components.schedule.Schedule.descount")
          }}
          </b-alert>
        </div>
      </b-form-group>

      <b-form-group v-if="typeSchedule !== 'PATIENT'" label-for="comments">
        <template slot="label">{{
          $t(
            "public.auth.professional.contact.schedule.modalCreate.comments"
          )
        }}:
        </template>
        <b-form-textarea id="comments" v-model="newEvent.comments" max-rows="6" rows="3"></b-form-textarea>
      </b-form-group>

      <b-form-group label-for="timelapse">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.reminder") }}:
          *
        </template>
        <b-row>
          <b-col>
            <b-form-group label-for="remainderEmail">
              <template slot="label">{{
                $t(
                  "public.components.schedule.Schedule.modalCreate.remainderEmail"
                )
              }}:
              </template>
              <b-form-radio-group id="remainderEmail" v-model="newEvent.remainderEmail">
                <b-form-radio value="true">{{
                  $t("generic.yes")
                }}
                </b-form-radio>
                <b-form-radio value="false">{{
                  $t("generic.no")
                }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <!--     <b-col v-if="newEvent.remainderSms">
            <b-form-group label-for="sms">
              <template slot="label"
                >{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.remainderSms"
                  )
                }}:
              </template>
              <b-form-radio-group
                v-model="newEvent.remainderSms"
                id="remainderSms"
              >
                <b-form-radio value="true">{{
                  $t("generic.yes")
                }}</b-form-radio>
                <b-form-radio value="false">{{
                  $t("generic.no")
                }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col v-if="newEvent.remainderWhatapp">
            <b-form-group label-for="whatapp">
              <template slot="label"
                >{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.remainderWhatapp"
                  )
                }}:
              </template>
              <b-form-radio-group
                v-model="newEvent.remainderWhatapp"
                id="remainderWhatapp"
              >
                <b-form-radio value="true">{{
                  $t("generic.yes")
                }}</b-form-radio>
                <b-form-radio value="false">{{
                  $t("generic.no")
                }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col v-if="newEvent.remainderPhone">
            <b-form-group label-for="phone">
              <template slot="label"
                >{{
                  $t(
                    "public.components.schedule.Schedule.modalCreate.remainderPhone"
                  )
                }}:
              </template>
              <b-form-radio-group
                v-model="newEvent.remainderPhone"
                id="remainderPhone"
              >
                <b-form-radio value="true">{{
                  $t("generic.yes")
                }}</b-form-radio>
                <b-form-radio value="false">{{
                  $t("generic.no")
                }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          -->
        </b-row>
        <b-form-select v-model="newEvent.timelapse" :options="timelapseSelect" class="form-control" v-bind:class="{
          'text-danger': isFormNewEventTimelapseErrors,
          'is-invalid': isFormNewEventTimelapseErrors,
        }" @blur="checkNewEventTimelapse(newEvent.timelapse)"></b-form-select>

        <ul v-if="isFormNewEventTimelapseErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.timelapse'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
    <b-modal id="modal-pay" centered hide-footer size="sm">
      <template #modal-title>{{
        $t("public.components.schedule.Schedule.modalPay.title")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalPay.btnCancel")
      }}
      </template>
      <div class="payment-btn-center">
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " id="btnPaypal" class="fab fa-paypal fa-4x fa-fw cursor-point" @click="showPaypalPayment"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaPaypal
        " :target="'btnPaypal'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.components.schedule.Schedule.modalPay.btnPaypal")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " id="btnStripe" class="fab fa-stripe fa-4x fa-fw cursor-point" @click="showStripePayment"></i>
        <b-popover  v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaStripe
        " :target="'btnStripe'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.components.schedule.Schedule.modalPay.btnStripe")
          }}
          </template>
        </b-popover>
        <i v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " id="btnWallet" class="fas fa-wallet fa-4x fa-fw cursor-point" @click="showCashPayment"></i>
        <b-popover v-if="
          user &&
          user.userOrganizations &&
          user.userOrganizations[0] &&
          user.userOrganizations[0].paymentModePasarelaWallet
        " :target="'btnWallet'" placement="botton" triggers="hover focus">
          <template #title>{{
            $t("public.components.schedule.Schedule.modalPay.btnWallet")
          }}
          </template>
        </b-popover>
      </div>
    </b-modal>
    <b-modal id="modal-check-paid-professional" centered hide-footer size="lg">
      <template #modal-title>
        {{
          $t(
            "public.components.schedule.Schedule.modalCheckPaidProfessional.title"
          )
        }}
      </template>
      <div class="payment-btn-center">
        <div v-for="(item, index) in paymentOutPlataforms" :key="index">
          <b-button v-if="item.active" class="mr-2" variant="success" @click="paidOffline(item.id)">
            {{ item.name }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-bank-account" centered size="lg" @ok="goOrganizationPrefereces">
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalBankAccount.btnCancel")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.components.schedule.Schedule.modalBankAccount.btnAdd")
      }}
      </template>
      <template #modal-title>
        {{ $t("public.components.schedule.Schedule.modalBankAccount.title") }}
      </template>

      {{ $t("public.components.schedule.Schedule.modalBankAccount.body") }}
    </b-modal>

    <b-modal id="modal-reschedule" centered @ok="rescheduleSave">
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalCreate.cancel")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.components.schedule.Schedule.modalCreate.reschedule")
      }}
      </template>
      <template #modal-title>
        {{
          $t("public.components.schedule.Schedule.modalCreate.rescheduleTitle")
        }}
      </template>

      <b-form-group label-for="date">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.date") }}:
          *
        </template>
        <date-picker v-model="dateTmp" :format="myFormat" :formatter="momentFormat" type="date"></date-picker>
        <vue-timepicker v-model="timeTmp" v-bind:class="{
          'text-danger': isFormNewEventTimeErrors,
          'is-invalid': isFormNewEventTimeErrors,
        }"></vue-timepicker>
        <ul v-if="isFormNewEventDateErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.date'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>

    <b-modal id="modal-interactive" centered @ok="interactiveSave">
      <template #modal-cancel>{{
        $t("public.components.schedule.Schedule.modalBankAccount.btnCancel")
      }}
      </template>
      <template #modal-ok> {{ $t("public.components.schedule.Schedule.modalCreate.btnCreate") }}
      </template>
      <template #modal-title>
        Evento interactivo
      </template>

      <b-form-group label-for="date">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.date") }}:
          *
        </template>
        <date-picker v-model="dateTmp" :format="myFormat" :formatter="momentFormat" type="date"></date-picker>
        <vue-timepicker v-model="timeTmp" v-bind:class="{
          'text-danger': isFormNewEventTimeErrors,
          'is-invalid': isFormNewEventTimeErrors,
        }"></vue-timepicker>
        <ul v-if="isFormNewEventDateErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.date'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="type">
        <template slot="label">{{ $t("public.components.schedule.Schedule.modalCreate.type") }}:
          *
        </template>

        <multiselect id="type-multiselect" v-model="newEvent.type" :options="typeSelect" :preserve-search="true"
          label="text" track-by="value" v-bind:class="{
            'text-danger': isFormNewEventTypeErrors,
            'is-invalid': isFormNewEventTypeErrors,
          }" v-bind:deselectGroupLabel="$t(
  'public.components.schedule.Schedule.multiselect.visitType.deselectGroupLabel'
)
  " v-bind:deselectLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.deselectLabel'
  )
    " v-bind:placeholder="$t(
    'public.components.schedule.Schedule.multiselect.visitType.placeholder'
  )
    " v-bind:selectGroupLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectGroupLabel'
  )
    " v-bind:selectLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectLabel'
  )
    " v-bind:selectedLabel="$t(
    'public.components.schedule.Schedule.multiselect.visitType.selectedLabel'
  )
    " @blur="checkNewEventType(newEvent.type)" @input="
    changeVisitType();
  getEventTotal();
  changeToInteractiveToEvent();
  ">
          <template slot="singleLabel" slot-scope="{ option }">
            <i :style="'color: ' + option.colour" class="fas fa-circle mr-2"></i>
            {{ option.text }}
          </template>
          <template slot="option" slot-scope="props">
            <b-list-group-item class="d-flex align-items-center">
              <i :style="'color: ' + props.option.colour" class="fas fa-circle mr-2"></i>
              <span class="mr-auto title-typography-color">{{
                props.option.text
              }}</span>
            </b-list-group-item>
          </template>
        </multiselect>
        <ul v-if="isFormNewEventTypeErrors">
          <li v-for="(error, index) in isValidateNewEvent.getErrors(
            'newEvent.type'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="name">
        <template slot="label">{{
          $t(
            "public.views.Pages.Professional.Contact.Contacts.modalCreate.name"
          )
        }}: *
        </template>
        <b-form-input id="nombre" v-model="interactive.name" :disabled="disabled" type="text"></b-form-input>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors(
            'interactive.name'
          )" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="maxParticipants">
        <template slot="label">Número de participantes: *
        </template>
        <b-form-input step="1" v-model="interactive.maxParticipants" type="number">
        </b-form-input>
      </b-form-group>
      <b-form-group label-for="comments">
        <template slot="label">{{
          $t(
            "public.auth.professional.contact.schedule.modalCreate.comments"
          )
        }}:
        </template>
        <b-form-textarea id="comments" v-model="newEvent.comments" max-rows="6" rows="3"></b-form-textarea>
      </b-form-group>

    </b-modal>
    <notifications group="notificacions" />
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import { mapActions, mapGetters } from "vuex";

import Timelapse from "../../json/Timelapse";
import EventPlacePayment from "../../json/EventPlacePayment";
import EventPlace from "../../json/EventPlace";

import EventInfo from "../../components/account/EventInfo";

import validator from "vue-m-validator";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import { loadStripe } from "@stripe/stripe-js";

import userService from "../../services/user";
import scheduleService from "../../services/schedule";
import patientService from "../../services/patient";
import professionalService from "../../services/professional";
import utilsService from "../../services/utils";
import invoiceService from "../../services/invoice";
import organizationService from "../../services/organization";
import interactiveService from "../../services/interactive";

export default {
  name: "Schedule",
  props: {
    typeSchedule: {},
    idProfessional: {},
    professionalsSchedule: [],
    visitTypeSchedule: [],
    header: true,
    eventId: null,
    dashboard: false,
  },
  components: {
    DatePicker,
    VueTimepicker,
    Multiselect,
    EventInfo,
  },
  watch: {
    professionalsSchedule: {
      handler() {
        if (this.idProfessional) {
          this.events = [];
          this.getAllEventsVuetifyProfessionalId(this.idProfessional);
        }
      },
    },
  },
  data() {
    return {
      interactive: { visitTypeId: null, name: "", comments: "", startedAt: null, force: false, maxParticipants: 10, priceCents: 9.99 },
      filteredEvents: [],
      type: "month",
      isLoadingPatients: false,
      reschedule: {
        id: "",
        date: "",
        time: "",
      },
      filterEvent: {
        professionals: [],
        visitTypes: [],
        viewStart: "",
        viewEnd: "",
      },
      total: 0,
      pageSize: 10000,
      currentPage: 0,
      typeContactOptions: [
        {
          text: this.$i18n.t(
            "public.components.schedule.Schedule.modalCreate.professional"
          ),
          value: "PROFESSIONAL",
        },
        {
          text: this.$i18n.t(
            "public.components.schedule.Schedule.modalCreate.patient"
          ),
          value: "PATIENT",
        },
      ],
      userId: localStorage.getItem("userId"),
      selectPatientId: "",
      //Paid
      contactsMulticonference: [],
      //Multiconference

      headers: [
        {
          text: this.$i18n.t(
            "public.components.schedule.Schedule.modalCitas.headers.name"
          ),
          align: "start",
          value: "name",
        },
        { text: "", value: "id" },
      ],
      //Wallet
      eventTotal: 0,
      patient: { walletBalance: 0 },
      user: {},
      create: true,
      //
      //Data validate form
      isFirstRun: true,
      isValidateNewEvent: validator,
      newEvent: { paymentPlace: "" },
      timelapseSelect: Timelapse,
      paymentPlaceSelect: EventPlacePayment,
      boxSelect: [],
      eventPlaceSelect: [],
      typeSelect: [],
      professionalSelect: [],
      patientSelect: [],
      focus: "",
      typeToLabel: {
        month: "Mes",
        week: "Semana",
        day: "Dia",
        "4day": "4 Dias",
      },
      weekView: [1, 2, 3, 4, 5, 6, 0],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      citaEvents: [],
      events: [],
      workScheduleDates: new Set(),
      workScheduleTimes: new Set(),
      loadCalendar: true,
      cita: {},
      avaibleTimes: [],
      avaibleDates: [],
      hourSelect: "",
      hourRange: [],
      minuteRange: [],
      dateTmp: "",
      timeTmp: "",
      force: false,
      start: this.getActualDateToVcalendar(),
      //Modal show event
      btnCheckPaid: false,
      btnCancel: false,
      btnVideoconference: false,
      btnGenerateInvoice: false,
      btnDownloadInvoice: false,
      btnPay: false,
      btnUpdate: false,
      //Settings patient
      settingsPatient: {
        remaindCitaEmail: false,
        notificationCitaEmail: false,
        remaindCitaWhatapp: false,
        notificationCitaWhatapp: false,
        remaindCitaSms: false,
        notificationCitaSms: false,
        createCita: false,
      },
      //Pay
      stripe: {
        publicKey: "",
        idSession: "",
      },
      paypal: {
        url: "",
      },
      //Visit type
      visitTypeMap: new Map(),
      //Check paid professional
      checkPaidProfessional: {},
      checkPaidPatient: {},
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      // seasons

      seasons: [],
      //Payment out platform
      paymentOutPlataforms: [],
    };
  },
  mounted() {
    xray.index();

    //Get value wallet total
    this.loadingWalletTotalPaymentPlaceSelect();
    //Open if get event in url
    this.checkEventOpen();
    //Verificacion pay
    this.verifyPay();
    //Combos
    if ("PATIENT" === this.typeSchedule) {
      this.getSettingsPatient(localStorage.getItem("userId"));
    } else {
      this.getProfessionalLead();
    }
    this.getAllProfessionals();

    this.getAllVisitType();
    // Schedule

    this.getAllEventsVuetify();

    //Global data
    this.getUser();

    //Init initial day
    this.getInitDay();

    this.getAllBoxes(localStorage.getItem("organizationId"));
  },
  computed: {
    //Form new event
    isFormNewEventprofessionalErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.professional");
      return errors && errors.length > 0;
    },
    isFormNewEventDateErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.date");
      return errors && errors.length > 0;
    },
    isFormNewEventTimeErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.time");
      return errors && errors.length > 0;
    },
    isFormNewEventTypeErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.type");
      return errors && errors.length > 0;
    },
    isFormNewEventPlaceErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.eventPlace");
      return errors && errors.length > 0;
    },
    isFormNewEventContactErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.contact");
      return errors && errors.length > 0;
    },
    isFormNewEventPriceErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.price");
      return errors && errors.length > 0;
    },
    isFormNewEventPaymentPlaceErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.payment");
      return errors && errors.length > 0;
    },
    isFormNewEventReferenceErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.comments");
      return errors && errors.length > 0;
    },
    isFormNewEventTimelapseErrors() {
      let errors = this.isValidateNewEvent.getErrors("newEvent.timelapse");
      return errors && errors.length > 0;
    },
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
    ...mapGetters({
      selectedUser: "Setting/userState",
    }),
  },
  methods: {
    interactiveSave() {
      let self = this;

      console.log(this.newEvent);

      let data = JSON.parse(JSON.stringify(this.interactive));

      data.visitTypeId = this.newEvent.type.value;
      data.comments = this.newEvent.comments;
      data.startedAt = utilsService.adjustDateTime(moment(this.dateTmp).format("DD/MM/yyyy") + " " + this.timeTmp, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")

      this.$awn.asyncBlock(
        interactiveService.create(data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SCHEDULED", info: "" });
          //Reload next 5 events
          if (self.dashboard) {
            self.$parent.getNextInteractive(5);
          }
          self.$bvModal.hide("modal-interactive");
          self.getAllEventsVuetify();
          self.$notify({
            group: "notificacions",
            title: self.$i18n.t(
              "public.components.schedule.Schedule.notification.title"
            ),
            text: self.$i18n.t(
              "public.components.schedule.Schedule.notification.desc"
            ),
            type: "success",
          });
        },
        (error) => {
          if (error.response && error.response.status === 402) {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text2"
              )
            );
          } else {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text2"
              )
            );
          }
        }
      );
    },
    moreDay(date) {
      let targetDate = new Date(date.date);
      let filteredEvents = this.events.filter(event => {
        let startDate = new Date(event.start);
        return startDate.getFullYear() === targetDate.getFullYear()
          && startDate.getMonth() === targetDate.getMonth()
          && startDate.getDate() === targetDate.getDate();
      });
      this.filteredEvents = filteredEvents;
      this.$root.$emit('bv::show::popover', 'popover-target-' + date.date);
    },
    filterEvents(date) {
      let targetDate = new Date(date);
      let filteredEvents = this.events.filter(event => {
        let startDate = new Date(event.start);
        return startDate.getFullYear() === targetDate.getFullYear()
          && startDate.getMonth() === targetDate.getMonth()
          && startDate.getDate() === targetDate.getDate();
      });

      filteredEvents.sort((a, b) => new Date(a.start) - new Date(b.start));

      return filteredEvents;
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    getOrganizationPaymentMode() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response.data) {
            let paymentPlaceSelectDelete = [];
            this.paymentPlaceSelect.forEach(function (item) {
              if (
                item.value === "OUT_PLATAFORM" &&
                response.data.paymentModeOutPlatform
              ) {
                paymentPlaceSelectDelete.push(item);
              } else if (
                item.value === "BEFORE_EVENT_ONLINE" &&
                response.data.paymentModeOutBefore
              ) {
                paymentPlaceSelectDelete.push(item);
              } else if (
                item.value === "AFTER_EVENT_ONLINE" &&
                response.data.paymentModeOutAfter
              ) {
                paymentPlaceSelectDelete.push(item);
              } else if (
                item.value === "WALLET" &&
                response.data.paymentModeWallet
              ) {
                paymentPlaceSelectDelete.push(item);
              }
            });
            self.paymentPlaceSelect = paymentPlaceSelectDelete;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        }
      );
    },
    rescheduleSave() {
      let self = this;

      this.reschedule.date = moment(this.dateTmp).format("DD/MM/yyyy");
      this.reschedule.time = this.timeTmp;

      let data = {
        dateTime: utilsService.adjustDateTime(this.reschedule.date + " " + this.reschedule.time, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
      };

      this.$awn.asyncBlock(
        scheduleService.reschedule(this.reschedule.id, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SCHEDULED", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.schedule.Schedule.notifications.titleUpdate"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.notifications.descReschedule"
              ),
              type: "success",
            });
            // Schedule

            self.getAllEventsVuetify();

            self.$parent.getNextEvents(5);

            self.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          if (error.response && error.response.status === 402) {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text2"
              )
            );
          } else {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text2"
              )
            );
          }
        },
        " "
      );

    },
    openReschedule(id, dateTime) {
      this.reschedule.id = id;
      this.dateTmp = new Date(dateTime);
      this.timeTmp = utilsService.adjustDateTimeInverse(dateTime, "HH:mm");

      this.$bvModal.hide("modal-cita");
      this.$bvModal.show("modal-reschedule");
    },
    getEvents(event) {
      const min = new Date(`${event.start.date}T00:00:00`);
      const max = new Date(`${event.end.date}T23:59:59`);

      this.filterEvent.viewStart = moment(min)
        .subtract(7, "days")
        .format("DD/MM/yyyy");
      this.filterEvent.viewEnd = moment(max)
        .add(7, "days")
        .format("DD/MM/yyyy");

      if (this.idProfessional) {
        this.events = [];
        this.getAllEventsVuetifyProfessionalId(this.idProfessional);
      }
    },
    morePrevent(evt) {
      evt.preventDefault();
    },
    async generateWorkScheduleDatesBlock(season) {
      let self = this;

      let dateStart = moment(season.dateStart, "DD/MM/yyyy");
      let dateEnd = moment(season.dateEnd, "DD/MM/yyyy");

      if (dateStart.isBefore(dateEnd)) {
        while (!dateStart.isSame(dateEnd)) {
          let add = dateStart.format("yyyy-MM-DD");

          if (this.workScheduleDates.has(add)) {
            this.workScheduleDates.delete(add);
          }

          //Hours
          if (season.seasonHours && season.seasonHours.length !== 0) {
            season.seasonHours.forEach(function (item) {
              var date = moment(new Date(add));

              date.set({
                hour: 0,
                minute: 0,
                second: 0,
              });

              var dateStart = moment(new Date(add));
              var dateEnd = moment(new Date(add));

              var time = moment(item.timeStart, "HH:mm");

              dateStart.set({
                hour: time.get("hour"),
                minute: time.get("minute"),
                second: time.get("second"),
              });

              var time = moment(item.timeEnd, "HH:mm");

              dateEnd.set({
                hour: time.get("hour"),
                minute: time.get("minute"),
                second: time.get("second"),
              });
              var time = {
                date: date.toDate(),
                start: dateStart.toDate(),
                end: dateEnd.toDate(),
              };
              self.avaibleTimes.push(time);
            });
          }

          dateStart.add(1, "days");
        }
      }
    },
    async addWorkScheduleDatesBlock(seasons) {
      let self = this;

      if (seasons && seasons.length !== 0) {
        seasons.forEach(function (season) {
          self.generateWorkScheduleDatesBlock(season);
        });
      }
    },
    async getWorkscheduleBlock() {
      let self = this;

      professionalService.getAllSeason(self.idProfessional).then(
        (response) => {
          if (response) {
            self.seasons = response.data;

            self.addWorkScheduleDatesBlock(self.seasons);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllSeason",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: self.idProfessional
            }),
          });
        }
      );
    },
    clickAvatar(title, file) {
      this.$swal(title);
    },
    moreInformationPatientAccordeon(patientId) {
      this.$root.$emit(
        "bv::toggle::collapse",
        "more-info-patient-" + patientId
      );
    },
    //Multiconference
    paymentPlaceContactSelect(contact) {
      let self = this;
      let clone = JSON.parse(JSON.stringify(this.paymentPlaceSelect));
      clone.forEach(function (item) {
        if (item.value === "WALLET") {
          if (contact) {
            // Wallet
            item.text = self.$i18n.t(
              "public.components.schedule.Schedule.descount1"
            );
          }
        }
      });
      return clone;
    },
    isFormContactsErrors(type, index) {
      if (type === "PAYMENT_PLACE") {
        let errors = this.isValidateNewEvent.getErrors(
          "newEvent.contacts[" + index + "].paymentPlace"
        );
        return errors && errors.length > 0;
      }
      if (type === "CONTACT") {
        let errors = this.isValidateNewEvent.getErrors(
          "newEvent.contacts[" + index + "].contact"
        );
        return errors && errors.length > 0;
      }
      if (type === "PRICE") {
        let errors = this.isValidateNewEvent.getErrors(
          "newEvent.contacts[" + index + "].price"
        );
        return errors && errors.length > 0;
      }
    },
    checkAndInitMulticonference(visitType) {
      let price = 0.0;

      if (visitType.priceOnlineActive) {
        price = visitType.priceOnline;
      }

      if (visitType.priceOfflineActive) {
        price = visitType.priceOffline;
      }

      let data = {
        type: "PATIENT",
        contact: "",
        price: price,
        paymentPlace: "OUT_PLATAFORM",
      };
      let data1 = {
        type: "PATIENT",
        contact: "",
        price: price,
        paymentPlace: "OUT_PLATAFORM",
      };

      //Cuando se actualiza se cargan de la otra cita
      if (this.create) {
        this.contactsMulticonference = [];

        this.contactsMulticonference.push(data);
        this.contactsMulticonference.push(data1);
      }
    },
    addContact() {
      //Set max price
      let maxPrice = 0.0;
      this.contactsMulticonference.forEach(function (item) {
        if (item.price > maxPrice) {
          maxPrice = item.price;
        }
      });
      let data = {
        type: "PATIENT",
        contact: [],
        price: maxPrice,
        paymentPlace: "OUT_PLATAFORM",
      };

      this.contactsMulticonference.push(data);
    },
    removeContact(index) {
      this.contactsMulticonference.splice(index, 1);
    },
    getEventTotal() {
      if (this.newEvent && this.newEvent.type && this.newEvent.type.value) {
        let visitType = this.visitTypeMap.get(this.newEvent.type.value);
        let onlineOrOffline = this.newEvent.eventPlace;

        if (visitType && onlineOrOffline) {
          if (onlineOrOffline === "ONLINE") {
            this.eventTotal = visitType.priceOnline;
            this.newEvent.price = visitType.priceOnline;
          }
          if (onlineOrOffline === "OFFLINE") {
            this.eventTotal = visitType.priceOffline;
            this.newEvent.price = visitType.priceOffline;
          }
        }
      }
    },
    async getProfessionalLead() {
      let self = this;
      this.$awn.asyncBlock(
        professionalService.get(this.idProfessional),
        (response) => {
          if (response) {
            self.newEvent.professionalLead = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.get",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idProfessional: self.idProfessional
            }),
          });
        }
      );
    },
    async getPatientWalletBalance(contact) {
      let self = this;

      patientService
        .get(contact.value)
        .then((response) => {
          if (response) {
            self.patient = response.data;
            // Wallet
            item.text = self.$i18n.t(
              "public.components.schedule.Schedule.descount1"
            );
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              idPatient: contact.value
            }),
          });
        });
    },
    async loadingWalletTotalPaymentPlaceSelect() {
      let self = this;

      this.changeVisitType();
      this.getEventTotal();
    },
    async checkEventOpen() {
      if (this.event && this.event.id) {
        this.getEvent(this.event.id, null);
      }
    },
    async getAllPaymentOutPlataform(organizationId) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.getAllPaymentOutPlataform(organizationId),
        (response) => {
          if (response) {
            self.paymentOutPlataforms = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllPaymentOutPlataform",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId
            }),
          });
        }
      );
    },
    goOrganizationPrefereces() {
      this.$router.push({
        name: "auth.professional.organization.preferences",
      });
    },
    changeToInteractiveToEvent() {

      if (this.newEvent.onlineType !== "INTERACTIVE") {

        this.$bvModal.show("modal-cita-crear");
        this.$bvModal.hide("modal-interactive");

      }
    },
    changeToInteractive() {

      if (this.newEvent.onlineType === "INTERACTIVE") {

        this.$bvModal.hide("modal-cita-crear");
        this.$bvModal.show("modal-interactive");

      }
    },
    //Visit type
    changeVisitType() {

      if (this.newEvent.type) {
        let visitTypeId = this.newEvent.type.value;
        let dateTime = moment(utilsService.adjustDateTime(this.newEvent.date + " " + this.newEvent.time, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"));

        if (visitTypeId) {
          let self = this;
          let deleteOffline = false;
          let deleteOnline = false;
          let visitTypeSelect = this.visitTypeMap.get(visitTypeId);

          this.checkAndInitMulticonference(visitTypeSelect);

          this.newEvent.onlineType = visitTypeSelect.onlineType;

          this.eventPlaceSelect = [];

          this.eventPlaceSelect = EventPlace.map((a) => Object.assign({}, a));

          this.eventPlaceSelect.forEach(function (item, index, object) {
            if (item.value === "ONLINE" && visitTypeSelect.priceOnlineActive) {
              item.text = item.text + "(" + visitTypeSelect.priceOnline + " €)";
            }
            if (
              item.value === "OFFLINE" &&
              visitTypeSelect.priceOfflineActive
            ) {
              item.text =
                item.text + "(" + visitTypeSelect.priceOffline + " €)";
            }
            if (item.value === "ONLINE" && !visitTypeSelect.priceOnlineActive) {
              deleteOnline = true;
            }
            if (
              item.value === "OFFLINE" &&
              !visitTypeSelect.priceOfflineActive
            ) {
              deleteOffline = true;
            }
          });
          // Check online
          if (
            dateTime &&
            dateTime.isValid() &&
            !deleteOnline &&
            dateTime > moment()
          ) {
            deleteOnline = false;
          } else {
            deleteOnline = true;
          }

          if (deleteOffline) {
            this.eventPlaceSelect.splice(1, 1);
          }

          if (deleteOnline) {
            this.eventPlaceSelect.splice(0, 1);
          }
        }

      }
    },
    myDayFormat(day) {
      if (day.weekday === 1) {
        return this.$i18n.t("calendar.weekday.monday");
      }

      if (day.weekday === 2) {
        return this.$i18n.t("calendar.weekday.tuesday");
      }

      if (day.weekday === 3) {
        return this.$i18n.t("calendar.weekday.wednesday");
      }

      if (day.weekday === 4) {
        return this.$i18n.t("calendar.weekday.thursday");
      }

      if (day.weekday === 5) {
        return this.$i18n.t("calendar.weekday.friday");
      }

      if (day.weekday === 6) {
        return this.$i18n.t("calendar.weekday.saturday");
      }

      if (day.weekday === 0) {
        return this.$i18n.t("calendar.weekday.sunday");
      }
    },
    //Invoice
    downloadInvoice(evt, invoices) {
      evt.preventDefault();
      let self = this;

      let last = null;

      if (invoices && invoices.length !== 0) {
        invoices.forEach(function (invoice) {
          if (last === null) {
            last = invoice;
          } else {
            if (last.id < invoice.id) {
              last = invoice;
            }
          }
        });

        this.$awn.asyncBlock(
          invoiceService.generatePdfInvoiceEvent(last.id),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_INVOICES_PDF", info: "" });
              var byteCharacters = atob(response.data.data);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              var file = new Blob([byteArray], {
                type: "application/pdf;base64",
              });
              var fileURL = URL.createObjectURL(file);

              var fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", "factura.pdf");
              document.body.appendChild(fileLink);

              fileLink.click();
              this.$notify({
                group: "notificacions",
                title: this.$i18n.t(
                  "public.components.schedule.Schedule.notification.invoice.title"
                ),
                text: this.$i18n.t(
                  "public.components.schedule.Schedule.notification.invoice.desc"
                ),
                type: "success",
              });
              //   this.$bvModal.hide("modal-cita");
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "invoiceService.generatePdfInvoiceEvent",
              module: "component-schedule-schedule",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                invoiceId: last.id
              }),
            });
          },
          " "
        );
      }
    },
    generateInvoice(evt, id, patientId) {
      evt.preventDefault();
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.generateInvoiceByPatient(id, patientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_INVOICES_GENERATE", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.schedule.Schedule.notification.invoice.title"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.notification.invoice.desc"
              ),
              type: "success",
            });
            self.getAllEventsVuetify();

            self.getEvent(self.event.id, null);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.generateInvoiceByPatient",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, patientId: patientId
            }),
          });
        },
        " "
      );
    },
    // Validation
    checkCancelCita(date) {
      if (this.user.organizationCancellationAppoimentsTime && date) {
        let nowLimit = moment().add(
          this.user.organizationCancellationAppoimentsTime,
          "minutes"
        );
        let start = moment(date);

        return start > nowLimit;
      } else {
        let start = moment(date);
        return moment() < start;
      }
    },
    async getInitDay() {
      var d = new Date();
      var datestring =
        new Date().getFullYear() +
        "-" +
        ("0" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date().getDate()).slice(-2);
      this.start = datestring;
    },
    //Pay
    async verifyPay() {
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined &&
        this.$route.query.paymentId !== undefined &&
        this.$route.query.eventId !== undefined &&
        this.$route.query.PayerID !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.eventId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined &&
        this.$route.query.token !== undefined
      ) {
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: this.$route.query.token,
            paymentIdPaypal: this.$route.query.paymentId,
            payerIDPaypal: this.$route.query.PayerID,
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.eventId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
      if (
        this.$route.query.action !== undefined &&
        this.$route.query.mode !== undefined &&
        this.$route.query.tokenback !== undefined
      ) {
        if (this.$route.query.action === "success") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.paySuccess(
            this.$route.query.patientId,
            this.$route.query.eventId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
        if (this.$route.query.action === "cancel") {
          let data = {
            tokenPaypal: "",
            paymentIdPaypal: "",
            payerIDPaypal: "",
          };

          this.payCancel(
            this.$route.query.patientId,
            this.$route.query.eventId,
            this.$route.query.mode,
            this.$route.query.tokenback,
            data
          );
        }
      }
    },
    openModalPay(evt, patientId) {
      evt.preventDefault();
      this.$bvModal.hide("modal-cita");
      this.selectPatientId = patientId;
      this.$bvModal.show("modal-pay");
    },
    showStripePayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payStripe(this.event.id, this.selectPatientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_STRIPE", info: "" });
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payStripe",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.event.id, selectPatientId: this.selectPatientId
            }),
          });
        },
        " "
      );
    },
    showPaypalPayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payPaypal(this.event.id, this.selectPatientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_PAYPAL", info: "" });
            self.paypal = response.data;
            window.location.href = self.paypal.url;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payPaypal",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.event.id, selectPatientId: this.selectPatientId
            }),
          });
        },
        " "
      );
    },
    showCashPayment() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.payCash(this.event.id, this.selectPatientId),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_WALLET", info: "" });
            self.getAllEventsVuetify();

            self.$bvModal.hide("modal-pay");
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.schedule.Schedule.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.notification.descPay"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          self.$swal(
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text"),
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text1"),
            this.$i18n.t("public.components.schedule.Schedule.errorSwal.text2")
          );
        },
        " "
      );
    },
    paySuccess(patientId, id, mode, token, data) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.paySuccess(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.schedule.Schedule.notification.title"
            ),
            text: this.$i18n.t(
              "public.components.schedule.Schedule.notification.descPay"
            ),
            type: "success",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.paySuccess",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            }),
          });
        },
        " "
      );
    },
    payCancel(patientId, id, mode, token, data) {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.payCancel(patientId, id, mode, token, data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_CANCEL", info: "" });
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.schedule.Schedule.notification.titleHasPrevious"
            ),
            text: this.$i18n.t(
              "public.components.schedule.Schedule.notification.noPayDesc"
            ),
            type: "error",
          });
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.payCancel",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: patientId, id: id, mode: mode, token: token, data: data
            }),
          });
        },
        " "
      );
    },
    //--
    getActualDateToVcalendar() {
      return (
        new Date().getFullYear() +
        "-" +
        ("0" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date().getDate()).slice(-2)
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkNewEventProfessional(_professional) {
      const professional = _professional;
      const RULE_1 = {
        expression: !professional || professional === "",
        name: "newEvent.professional",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erProfessional"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventDate(validate) {
      const RULE_1 = {
        expression: !validate,
        name: "newEvent.date",
        msg: this.$i18n.t("public.components.schedule.Schedule.errors.erDate"),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventType(_type) {
      const TYPE = _type != null ? _type.toString() : null;
      const RULE_1 = {
        expression: !TYPE || TYPE === "",
        name: "newEvent.type",
        msg: this.$i18n.t("public.components.schedule.Schedule.errors.erType"),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventPrice(_price) {
      const PRICE = _price != null ? _price.toString() : null;
      const RULE_1 = {
        expression: !PRICE || PRICE === "",
        name: "newEvent.price",
        msg: this.$i18n.t("public.components.schedule.Schedule.errors.erPrice"),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkContactsWallet() {
      let self = this;
      if (
        this.contactsMulticonference &&
        this.contactsMulticonference.length !== 0
      ) {
        this.contactsMulticonference.forEach(function (item, index) {
          if (item.paymentPlace === "WALLET") {
            self.checkWalletMulticonference(item.contact.walletBalance, index);
          } else {
            self.checkWalletMulticonference(false, index);
          }
        });
      }
    },
    checkArrayContactsProperties() {
      let self = this;
      if (
        this.contactsMulticonference &&
        this.contactsMulticonference.length !== 0
      ) {
        this.contactsMulticonference.forEach(function (item, index) {
          self.checkNewEventContactsProperties(
            index,
            item.contact,
            item.price,
            item.paymentPlace
          );
        });
      }
    },
    checkNewEventContactsProperties(index, contact, price, paymentPlace) {
      const CONTACT = contact;
      const RULE_1 = {
        expression: !CONTACT || CONTACT === "",
        name: "newEvent.contacts[" + index + "].contact",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erContact"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);

      const PRICE = price;
      const RULE_2 = {
        expression: PRICE === "",
        name: "newEvent.contacts[" + index + "].price",
        msg: this.$i18n.t("public.components.schedule.Schedule.errors.erPrice"),
      };
      this.isValidateNewEvent.addRule(RULE_2);

      const PAYMENT_PLACE = paymentPlace;
      const RULE_3 = {
        expression: !PAYMENT_PLACE || PAYMENT_PLACE === "",
        name: "newEvent.contacts[" + index + "].paymentPlace",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erPayment"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_3);
      this.notFirst();
    },
    checkNewEventContacts(_contacts) {
      const CONTACT = _contacts;
      const RULE_1 = {
        expression: _contacts,
        name: "newEvent.contact",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erContacts"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventContact(_contact) {
      const CONTACT = _contact ? _contact.toString() : null;
      const RULE_1 = {
        expression: !CONTACT || CONTACT === "",
        name: "newEvent.contact",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erContact"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventPlace(_place) {
      const PLACE = _place;
      const RULE_1 = {
        expression: !PLACE || PLACE === "",
        name: "newEvent.eventPlace",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erEventPlace"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventPaymentPlace(_payment) {
      const PAYMENT = _payment.trim();
      const RULE_1 = {
        expression: !PAYMENT || PAYMENT === "",
        name: "newEvent.payment",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erPayment"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkNewEventTimelapse(_timelapse) {
      const TIMELAPSE = _timelapse;

      const RULE_1 = {
        expression: TIMELAPSE === "",
        name: "newEvent.timelapse",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erReminder"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkWalletMulticonference(valid, index) {
      const RULE_1 = {
        expression: valid,
        name: "newEvent.contacts[" + index + "].wallet",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erPayment1"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    checkWallet(valid) {
      const RULE_1 = {
        expression: !valid,
        name: "newEvent.payment",
        msg: this.$i18n.t(
          "public.components.schedule.Schedule.errors.erPayment1"
        ),
      };
      this.isValidateNewEvent.addRule(RULE_1);
      this.notFirst();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    checkPaidForProfessional(evt, id, patientId) {
      evt.preventDefault();
      this.checkPaidProfessional.id = id;
      this.checkPaidPatient.id = patientId;
      this.$bvModal.show("modal-check-paid-professional");
    },
    paidOffline(mode) {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.paidOffline(
          this.checkPaidProfessional.id,
          mode,
          this.checkPaidPatient.id
        ),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PATIENT_PAYMENT_SUCCESS_OFFLINE", info: "" });
            this.$bvModal.hide("modal-check-paid-professional");

            self.getEvent(self.event.id, null);
            self.getAllEventsVuetify();
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.schedule.Schedule.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.notification.markPaidCorrectly"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.paidOffline",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              checkPaidProfessional: this.checkPaidProfessional.id,
              mode: mode,
              checkPaidPatient: this.checkPaidPatient.id
            }),
          });
        }
      );
    },
    checkDeviceAndRedirectMobileApp() {
      var is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      );
      var is_safari_or_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit/i.test(
        navigator.userAgent
      );

      if (is_uiwebview || is_safari_or_uiwebview) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("iphone") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }

      if (navigator.userAgent.toLowerCase().indexOf("ipad") > -1) {
        window.location.href =
          "https://apps.apple.com/us/app/cita-io/id1643449872";
      }
      if (this.$device && this.$device.os_name && this.$device.os_name.name) {
        if (this.$device.os_name.name.includes("iOS")) {
          window.location.href =
            "https://apps.apple.com/us/app/cita-io/id1643449872";
        }
      }
    },
    videoconference(paymentPlace, paid) {
      if (paymentPlace !== "BEFORE_EVENT_ONLINE" || paid) {
        utilsService.auditActivity({ action: "VIEW", module: "JOIN_EVENT", info: "" });
        // this.checkDeviceAndRedirectMobileApp();
        let href =
        process.env.VUE_APP_BASE_URL_WEBAPP + "auth/room?eventId="+ 
        this.event.id;
        window.open(href, "_blank");
      } else {
        if (this.user.role === "PATIENT") {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.schedule.Schedule.errors.videoconference.patient.before.title"
            ),
            text: this.$i18n.t(
              "public.components.schedule.Schedule.errors.videoconference.patient.before.text"
            ),
            type: "error",
          });
          this.$bvModal.hide("modal-cita");
          this.$bvModal.show("modal-pay");
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.schedule.Schedule.errors.videoconference.professional.before.title"
            ),
            text: this.$i18n.t(
              "public.components.schedule.Schedule.errors.videoconference.professional.before.text"
            ),
            type: "error",
          });
        }
      }
    },
    checkFormNewEvent() {
      this.isValidateNewEvent.errors = [];

      if (
        this.professionalsSchedule &&
        this.professionalsSchedule.length !== 0
      ) {
        this.checkNewEventProfessional(this.newEvent.professionalLeads);
      }

      if (this.newEvent.onlineType === "MULTICONFERENCE") {
        if (
          this.contactsMulticonference &&
          this.contactsMulticonference.length >= 2
        ) {
          this.checkNewEventContacts(false);
          this.checkArrayContactsProperties();
          this.checkContactsWallet();
        } else {
          this.checkNewEventContacts(true);
        }
      } else {
        this.checkNewEventContact(this.newEvent.contact);
        if (
          this.newEvent &&
          this.newEvent.paymentPlace === "WALLET" &&
          this.patient &&
          this.patient.walletBalance &&
          this.eventTotal
        ) {
          this.checkWallet(true);
        }
        this.checkNewEventPrice(this.newEvent.price);
      }

      if (!this.newEvent.date || !this.newEvent.time) {
        this.checkNewEventDate(false);
      }

      this.checkNewEventPaymentPlace(this.newEvent.paymentPlace);
      this.checkNewEventType(this.newEvent.type);
      this.checkNewEventPlace(this.newEvent.eventPlace);

      this.checkNewEventTimelapse(this.newEvent.timelapse);
    },
    saveFormNewEvent(evt) {
      evt.preventDefault();
      if (this.create) {
        this.checkFormNewEvent();
        if (this.isValidateNewEvent.errors.length === 0) {
          //Check if event is timeout workschedule
          if (this.isCheckMinutesHour()) {
            this.createEvent();
          } else {
            this.$swal({
              title: this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text3"
              ),
              text: this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text4"
              ),
              showCancelButton: false,
              confirmButtonText: this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.continue"
              ),
              showCloseButton: true,
              showLoaderOnConfirm: true,
            }).then((result) => {
              if (result.value) {
                this.createEvent();
              }
            });
          }
        } else {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.components.schedule.Schedule.errors.erTitle"
            ),
            text: this.$i18n.t(
              "public.components.schedule.Schedule.errors.erStep1"
            ),
            type: "error",
          });
        }
      }
    },
    async getUser() {
      let self = this;

      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;

            if (self.user.role !== "PATIENT") {
              this.getOrganizationPaymentMode();
            }

            self.getAllPaymentOutPlataform(
              localStorage.getItem("organizationId")
            );
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            }),
          });
        });
    },
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                value: item.id,
                text: item.name,
                colour: item.colour,
              });
            });
            self.typeSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllVisitTypeActive",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAllActive()
        .then((response) => {
          if (response) {
            let combo = [];
            response.data.forEach(function (item) {
              let name = "";

              if (item.name) {
                name = name + item.name + " ";
              }

              if (item.lastname) {
                name = name + item.lastname + " (";
              }
              if (item.document) {
                name = name + item.document + " - ";
              }
              if (item.email) {
                name = name + item.email + ")";
              }
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text: name,
                file: item.avatar,
              };
              combo.push(data);
            });
            self.professionalSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllActive",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        });
    },
    getAllPatients(query) {
      let self = this;

      if (query.length > 2) {
        self.isLoadingPatients = true;

        let data = { filter: query, status: "WORK" };

        patientService
          .getAllContacts(0, 100000, data)
          .then((response) => {
            if (response) {
              let combo = [];
              response.data.content.forEach(function (item) {
                let data = {
                  avatar: item.avatarUrl
                    ? item.avatarUrl +
                    "/" +
                    localStorage.getItem("authorization")
                    : "",
                  uuid: item.uuid,
                  value: item.id,
                  walletBalance: item.walletBalance,
                  file: item.avatar,
                  text:
                    item.name +
                    " " +
                    item.lastname +
                    " (" +
                    item.document +
                    ") " +
                    " (" +
                    item.email +
                    ") ",
                };
                combo.push(data);
              });
              self.patientSelect = combo;
              self.isLoadingPatients = false;
            }
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAllContacts",
              module: "component-schedule-schedule",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                data: data
              }),
            });
            self.isLoadingPatients = false;
          });
      }
    },
    ajustObjectMulticonference() {
      let clone = JSON.parse(JSON.stringify(this.contactsMulticonference));
      if (clone && clone.length !== 0) {
        clone.forEach(function (item, index) {
          item.contact = item.contact.value;
        });
      }
      return clone;
    },
    ajustObjectType() {
      if (this.newEvent.type) {
        let clone = JSON.parse(JSON.stringify(this.newEvent.type));
        if (clone && clone.value) {
          let data = clone.value;
          clone = data;
        }
        return clone;
      }
    },
    ajustObjectContact() {
      if (
        this.newEvent.contact &&
        this.newEvent.onlineType !== "MULTICONFERENCE"
      ) {
        let clone = JSON.parse(JSON.stringify(this.newEvent.contact));
        if (clone && clone.value) {
          let data = clone.value;
          clone = data;
        }
        return clone;
      }
    },
    ajustObjectProfessional() {
      if (
        this.typeSchedule !== "PATIENT" &&
        this.professionalsSchedule &&
        this.professionalsSchedule.length !== 0
      ) {
        if (this.dashboard) {
          return this.newEvent.professionalLeads.idProfessional;
        } else {
          return this.idProfessional;
        }
      } else {
        return this.idProfessional;
      }
    },
    ajustForceEvent() {
      return this.force;
    },
    createEvent() {
      let self = this;

      let data = {
        id: this.newEvent.id,
        professional: this.ajustObjectProfessional(),
        dateTime: utilsService.adjustDateTime(this.newEvent.date + " " + this.newEvent.time, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
        type: this.ajustObjectType(),
        contacts: this.ajustObjectMulticonference(),
        contact: this.ajustObjectContact(),
        price: this.newEvent.price,
        paymentPlace: this.newEvent.paymentPlace,
        box: this.newEvent.box,
        eventPlace: this.newEvent.eventPlace,
        comments: this.newEvent.comments,
        remainderEmail: this.newEvent.remainderEmail,
        remainderPhone: this.newEvent.remainderPhone,
        remainderSms: this.newEvent.remainderSms,
        remainderWhatapp: this.newEvent.remainderWhatapp,
        force: this.ajustForceEvent(),
        timelapse: this.newEvent.timelapse,
      };

      this.$awn.asyncBlock(
        scheduleService.createEvent(data),
        (response) => {
          utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SCHEDULED", info: "" });
          //Reload next 5 events
          if (self.dashboard) {
            self.$parent.getNextEvents(5);
          }
          self.$bvModal.hide("modal-cita-crear");
          self.getAllEventsVuetify();
          self.$notify({
            group: "notificacions",
            title: self.$i18n.t(
              "public.components.schedule.Schedule.notification.title"
            ),
            text: self.$i18n.t(
              "public.components.schedule.Schedule.notification.desc"
            ),
            type: "success",
          });
        },
        (error) => {
          if (error.response && error.response.status === 402) {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal.text2"
              )
            );
          } else {
            self.$swal(
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text1"
              ),
              this.$i18n.t(
                "public.components.schedule.Schedule.errorSwal1.text2"
              )
            );
          }
        }
      );
    },
    async getAllEventsVuetifyProfessionalId(professionalId) {
      let self = this;

      let professionals = [];

      if (
        this.professionalsSchedule &&
        this.professionalsSchedule.length !== 0
      ) {
        this.professionalsSchedule.forEach(function (item) {
          professionals.push(item.idProfessional);
        });
      } else {
        professionals.push(professionalId);
      }

      let data = {
        visitTypes: [],
        professionals: professionals,
        start: moment(this.filterEvent.viewStart, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
        end: moment(this.filterEvent.viewEnd, "DD/MM/YYYY").format(
          "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
        ),
      };
      this.$awn.asyncBlock(
        scheduleService.getAllEventsVuetifyFilter(
          this.currentPage,
          this.pageSize,
          data
        ),
        (response) => {
          if (response) {
            self.events = [];
            response.data.content.forEach(function (item) {
              if (
                new Date(item.start).getTime() > 0 &&
                new Date(item.end).getTime() > 0
              ) {
                const event = {
                  id: item.id,
                  title: item.title,
                  name: item.title,
                  start: moment(item.start).toDate(),
                  end: moment(item.end).toDate(),
                  color: item.color,
                  timed: item.timed,
                  type: item.type,
                  paid: item.paid,
                  online: item.online,
                  patients: item.patients,
                  professional: item.professional,
                  visitType: item.visitType,
                  minutes: item.minutes,
                  invoice: item.invoice,
                  startRaw: item.start,
                  endRaw: item.end,
                };
                self.events.push(event);
              }
            });
            if (self.typeSchedule !== "PATIENT") {
              if (
                this.professionalsSchedule &&
                this.professionalsSchedule.length !== 0
              ) {
                self.getAllWorkScheduleEvents(
                  this.professionalsSchedule[0].idProfessional
                );
              } else if (
                this.visitTypeSchedule &&
                this.visitTypeSchedule.length !== 0
              ) {
              } else {
                self.getAllWorkScheduleEvents(this.idProfessional);
              }
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllEventsVuetifyFilter",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              data: data
            }),
          });
        }
      );
    },
    async getAllEventsVuetify() {
      let self = this;

      if (this.idProfessional) {
        self.events = [];
        this.getAllEventsVuetifyProfessionalId(this.idProfessional);
      } else {
        let data = {};
        this.$awn.asyncBlock(
          scheduleService.getAllEventsVuetifyFilter(
            this.currentPage,
            this.pageSize,
            data
          ),
          (response) => {
            if (response) {
              self.events = [];
              response.data.content.forEach(function (item) {
                const event = {
                  id: item.id,
                  title: item.title,
                  name: item.title,
                  start: new Date(item.start),
                  end: new Date(item.end),
                  color: item.color,
                  timed: item.timed,
                  type: item.type,
                  paid: item.paid,
                  online: item.online,
                  patients: item.patients,
                  professional: item.professional,
                  visitType: item.visitType,
                  minutes: item.minutes,
                  startRaw: item.start,
                  endRaw: item.end,
                };
                self.events.push(event);
              });

              if (self.typeSchedule !== "PATIENT") {
                self.getAllWorkScheduleEvents(this.idProfessional);
              }
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "scheduleService.getAllEventsVuetifyFilter",
              module: "component-schedule-schedule",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                data: data
              }),
            });
          }
        );
      }
    },
    async getAllEventsByDate(data) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.getAllEventsByDate(data),
        (response) => {
          if (response) {
            self.allEventsByWorkScheduleTable = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllEventsByDate",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            }),
          });
        }
      );
    },
    async duplicateWorkScheduleDates() {
      let clone = new Set();

      let weeks = 100;

      for (var i = 0; i <= weeks; i++) {
        this.workScheduleDates.forEach(function (item) {
          clone.add(
            moment(item)
              .add(i * 7, "days")
              .format("YYYY-MM-DD")
          );
          clone.add(
            moment(item)
              .subtract(i * 7, "days")
              .format("YYYY-MM-DD")
          );
        });
      }

      this.workScheduleDates = clone;
    },
    async getAllWorkScheduleEvents(professionalId) {
      let self = this;

      professionalService.getAllSchedulesWorkschedule(professionalId).then(
        (response) => {
          if (response) {
            self.avaibleDates = [];

            self.workScheduleDates = new Set();

            response.data.forEach(function (item) {
              var date = new Date(item.start);
              date = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                0,
                0,
                0
              );
              self.avaibleDates.push(date);

              var start = new Date(item.start);
              var end = new Date(item.end);
              var time = {
                date: date,
                start: start,
                end: end,
              };
              self.avaibleTimes.push(time);

              var date = moment(start).format("YYYY-MM-DD");

              if (!self.workScheduleDates.has(date)) {
                self.workScheduleDates.add(date);
              }
            });
            self.duplicateWorkScheduleDates();
            self.getWorkscheduleBlock();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllSchedulesWorkschedule",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: professionalId
            }),
          });
        }
      );
    },
    deleteEvent(id) {
      let self = this;

      this.$swal({
        title: this.$i18n.t(
          "public.components.schedule.Schedule.errorSwal2.text"
        ),
        showCancelButton: true,
        confirmButtonText: this.$i18n.t(
          "public.components.schedule.Schedule.errorSwal2.send"
        ),
        cancelButtonText: this.$i18n.t(
          "public.components.schedule.Schedule.errorSwal2.noSend"
        ),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        this.$awn.asyncBlock(
          scheduleService.deleteEvent(id, result.value ? result.value : false),
          (response) => {
            if (response) {
              utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_SCHEDULED", info: "" });
              this.$bvModal.hide("modal-cita");
              self.getAllEventsVuetify();
              self.$parent.getNextEvents(5);
            }
          },
          (error) => {
            utilsService.auditErrorFrontent({
              info: "scheduleService.deleteEvent",
              module: "component-schedule-schedule",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                id: id
              }),
            });
          }
        );
      });
    },
    async getEvent(id, date) {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.getEvent(id),
        (response) => {
          if (response) {
            self.event = response.data;

            self.cita = {
              id: response.data.id,
              professionalLead: response.data.professionalLead,
              comments: response.data.comments,
              visitType: response.data.visitType,
              type: response.data.visitType.name,
              time: response.data.visitType.duration + response.data.extraTime,
              totalMinutes: response.data.totalMinutes,
              startAt: response.data.startedAt,
              price:
                response.data.visitType.priceOnlineActive === true
                  ? response.data.visitType.priceOnline
                  : response.data.visitType.priceOffline,
              paid: response.data.payment !== null,
              paymentPlace: response.data.paymentPlace,
              eventPlace: response.data.eventPlace,
              patients: response.data.patients,
              billings: response.data.billings,
              professionals: response.data.professionals,
              typeRoom: response.data.typeRoom,
              force: response.data.force,
              organization: response.data.organization,
              finishedAt: response.data.finishedAt,
            };


            if ("PROFESSIONAL" === self.typeSchedule) {
              self.btnCancel = false;

              response.data.billings.forEach(function (item) {
                if (item.invoices && item.invoices.length !== 0) {
                  self.btnCancel = true;
                }
              });
            } else {

              self.btnCancel = true;

              if (self.selectedOrganization.cancellationAppoiments) {

                self.btnCancel = false;

                response.data.billings.forEach(function (item) {
                  if (item.invoices && item.invoices.length !== 0) {
                    self.btnCancel = true;
                  }
                });
              }
            }

            if (response.data.join) {
              self.btnVideoconference = false;
            } else {
              self.btnVideoconference = true;
            }

            let billing;

            if ("PATIENT" === self.typeSchedule) {
              if (response.data.billings) {
                response.data.billings.forEach(function (item) {
                  if (item.patient.id === self.user.id) {
                    billing = item;
                  }
                });

                if (billing) {
                  if (billing.paymentPlace === "BEFORE_EVENT_ONLINE") {
                    if (
                      billing.payment &&
                      billing.payment.paymentStatus === "SUCCESS"
                    ) {
                      self.btnVideoconference = false;
                    } else {
                      self.btnVideoconference = true;
                    }
                  }

                  if (
                    billing.payment &&
                    billing.payment.paymentStatus === "SUCCESS"
                  ) {
                    self.btnCancel = true;
                  }
                }
              }
            }

            if (self.cita.eventPlace !== "ONLINE" && !self.cita.paid) {
              self.btnCheckPaid = false;
            } else {
              self.btnCheckPaid = true;
            }

            if (date >= new Date()) {
              self.btnUpdate = false;
            } else {
              self.btnUpdate = true;
            }

            self.btnPay = self.cita.paid;

            self.$bvModal.show("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getEvent",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            }),
          });
        }
      );
    },
    clearForm() {
      this.newEvent = {};
      this.newEvent.price = 0;
      this.eventPlaceSelect = [];
      this.newEvent.id = undefined;
      this.dateTmp = "";
      this.newEvent.date = "";
      this.newEvent.time = "";
      this.timeTmp = "";
      this.newEvent.eventPlace =
        this.eventPlaceSelect[0] != null
          ? this.eventPlaceSelect[0].value
          : null;
      this.newEvent.paymentPlace =
        this.paymentPlaceSelect[0] != null
          ? this.paymentPlaceSelect[0].value
          : null;
      this.newEvent.comments = "";
      this.newEvent.onlineType = "MONOCONFERENCE";
      this.newEvent.timelapse = "30";
      this.newEvent.remainderEmail = true;
      this.newEvent.remainderPhone = true;
      this.newEvent.remainderSms = true;
      this.newEvent.remainderWhatapp = false;
      this.newEvent.box = "";
      this.newEvent.type = "";
      this.contactsMulticonference = [];
      this.patientSelect = [];
      this.patient = { walletBalance: 0 };
    },
    open(date) {
      this.create = true;
      this.clearForm();

      if (date) {
        this.dateTmp = new Date(date);
        this.dateTmp = new Date(
          this.dateTmp.getFullYear(),
          this.dateTmp.getMonth(),
          this.dateTmp.getDate(),
          0,
          0,
          0
        );
        this.calculateTimeDay(this.dateTmp);
      } else {
        this.dateTmp = new Date();
        this.calculateTimeDay(this.dateTmp);
      }

      this.newEvent.professional = this.user.id;

      this.isValidateNewEvent.errors = [];
      this.$bvModal.show("modal-cita-crear");
    },
    openModal(date) {
      if (
        this.workScheduleDates &&
        this.workScheduleDates.size !== 0 &&
        !this.workScheduleDates.has(date)
      ) {
        this.$swal({
          title: this.$i18n.t(
            "public.components.schedule.Schedule.errorSwal.text3"
          ),
          text: this.$i18n.t(
            "public.components.schedule.Schedule.errorSwal.text4"
          ),
          showCancelButton: false,
          confirmButtonText: "Continuar",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.force = true;
            this.open(date);
          }
        });
      } else {
        this.open(date);
      }

      this.force = false;
    },
    disabledDate(date) {
      // En caso de que no tenga horario se permite añadir todas las fechas
      if (this.avaibleDates.length !== 0) {
        return !this.avaibleDates.find((item) => {
          return item.getTime() == date.getTime();
        });
      } else {
        return false;
      }
    },
    formattedDate(d = new Date()) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${day}/${month}/${year}`;
    },
    isValidWorkschedule(date) {
      this.newEvent.date = this.formattedDate(date);

      let self = this;

      var dates = this.avaibleTimes.filter((item) => {
        return item.date.getTime() == date.getTime();
      });

      this.hourRange = [];

      dates.forEach(function (valor, indice, array) {
        //Calculate hours avaible
        for (var i = valor.start.getHours(); i <= valor.end.getHours(); i++) {
          self.hourRange.push(i);
        }
      });
      this.newEvent.time = "";
      this.validateDate(false, false, this.newEvent.date);
    },
    calculateTimeDay(date) {
      // En caso de que no tenga horario se permite añadir todas las fechas

      this.newEvent.date = this.formattedDate(date);
      this.hourRange = [];
      //Permitimos todas las horas
      for (var i = 0; i < 24; i++) {
        this.hourRange.push(i);
      }
      this.calculateMinutesHour(null);

      this.changeVisitType();
    },
    validateDate(hour, minuts, date) {
      if (hour && minuts && date) {
        this.checkNewEventDate(true);
      } else {
        this.checkNewEventDate(false);
      }
    },
    isWorkSchedule(date) {
      return this.workScheduleDates.has(date);
    },
    isCheckMinutesHour() {
      if (this.avaibleDates.length !== 0) {
        if (this.validateHhMm(this.timeTmp)) {
          let minutes = this.timeTmp.substring(
            this.timeTmp.indexOf(":") + 1,
            this.timeTmp.length
          );
          let hour = this.timeTmp.substring(0, this.timeTmp.indexOf(":"));

          let avaible = false;

          this.avaibleTimes.forEach(function (item) {
            let start = moment(item.start).toDate();
            let end = moment(item.end).toDate();
            let now = moment(item.start).toDate();

            now.setHours(hour);
            now.setMinutes(minutes);

            if (start <= now && end >= now) {
              avaible = true;
            }
          });
          if (avaible) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    validateHhMm(timeTmp) {
      var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(
        timeTmp
      );

      return isValid;
    },
    calculateMinutesHour(event) {
      this.minuteRange = [];

      if (event) {
        this.newEvent.time = event.data.HH + ":" + event.data.mm;

        this.validateDate(event.data.HH, event.data.mm, this.newEvent.date);
        this.minuteRange = [[0, 60]];
      }

      this.changeVisitType();
    },
    //Settings patient
    async getSettingsPatient(id) {
      let self = this;
      this.$awn.asyncBlock(
        patientService.getSettings(id),
        (response) => {
          self.disabled = false;
          if (response) {
            let obj = {
              remaindCitaEmail:
                response.data.remaindCitaEmail === null
                  ? false
                  : response.data.remaindCitaEmail,
              notificationCitaEmail:
                response.data.notificationCitaEmail === null
                  ? false
                  : response.data.notificationCitaEmail,
              remaindCitaWhatapp:
                response.data.remaindCitaWhatapp === null
                  ? false
                  : response.data.remaindCitaWhatapp,
              notificationCitaWhatapp:
                response.data.notificationCitaWhatapp === null
                  ? false
                  : response.data.notificationCitaWhatapp,
              remaindCitaSms:
                response.data.remaindCitaSms === null
                  ? false
                  : response.data.remaindCitaSms,
              notificationCitaSms:
                response.data.notificationCitaSms === null
                  ? false
                  : response.data.notificationCitaSms,
              createCita:
                response.data.createCita === null
                  ? false
                  : response.data.createCita,
            };
            self.settingsPatient = obj;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getSettings",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            }),
          });
        }
      );
    },
    async getAllBoxes(organizationId) {
      let self = this;

      organizationService
        .findAllBoxes(organizationId, 0, 100000)
        .then((response) => {
          if (response) {
            let combo = [];
            response.data.content.forEach(function (item) {
              combo.push({
                value: item.id,
                text: item.name,
              });
            });
            self.boxSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findAllBoxes",
            module: "component-schedule-schedule",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: organizationId
            }),
          });
        });
    },
  },
};
</script>
